import { collection, addDoc, getDocs, doc, getDoc, updateDoc, deleteDoc, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';

// Collection reference
const citiesCollection = collection(db, 'cities');

// Interface for city
export interface City {
  id: string;
  name: string;
  state?: string;
  country?: string;
  active: boolean;
}

// Get all cities
export const getCities = async (): Promise<City[]> => {
  try {
    const querySnapshot = await getDocs(query(citiesCollection, orderBy('name', 'asc')));
    const cities = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as City));
    
    return cities;
  } catch (error) {
    console.error('Error getting cities: ', error);
    return [];
  }
};

// Get active cities
export const getActiveCities = async (): Promise<City[]> => {
  try {
    const cities = await getCities();
    return cities.filter(city => city.active);
  } catch (error) {
    console.error('Error getting active cities: ', error);
    return [];
  }
};

// Add a new city
export const addCity = async (city: Omit<City, 'id'>): Promise<string> => {
  try {
    const docRef = await addDoc(citiesCollection, {
      ...city,
      createdAt: new Date()
    });
    
    return docRef.id;
  } catch (error) {
    console.error('Error adding city: ', error);
    throw error;
  }
};

// Update a city
export const updateCity = async (id: string, data: Partial<City>): Promise<void> => {
  try {
    const docRef = doc(db, 'cities', id);
    await updateDoc(docRef, data);
  } catch (error) {
    console.error('Error updating city: ', error);
    throw error;
  }
};

// Delete a city
export const deleteCity = async (id: string): Promise<void> => {
  try {
    const docRef = doc(db, 'cities', id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error('Error deleting city: ', error);
    throw error;
  }
};